import { h } from 'preact';

const ArrowRight = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}>
			<path d="M28.8608 17.0168L20.2757 24.5669C20.0884 24.7549 19.9832 25.0095 19.9832 25.275C19.9832 25.5404 20.0884 25.795 20.2757 25.983C20.4637 26.1703 20.7183 26.2755 20.9837 26.2755C21.2491 26.2755 21.5037 26.1703 21.6917 25.983L31.9829 16.7238C32.3729 16.3318 32.3729 15.6998 31.9829 15.3078L21.6917 6.01665C21.5036 5.82954 21.249 5.72451 20.9837 5.72451C20.7184 5.72451 20.4638 5.82954 20.2757 6.01665C20.0884 6.20465 19.9832 6.45925 19.9832 6.72466C19.9832 6.99008 20.0884 7.24467 20.2757 7.43267L28.8608 15.0168L1.27541 15.0168C1.01019 15.0168 0.755828 15.1221 0.568288 15.3097C0.380749 15.4972 0.275391 15.7516 0.275391 16.0168C0.275391 16.282 0.380749 16.5364 0.568288 16.7239C0.755828 16.9115 1.01019 17.0168 1.27541 17.0168H28.8608Z" />
		</svg>
	);
};

export default ArrowRight;
